export interface IExportLayers {
  basemapLabels: boolean
  buildings3d: boolean
  locationShapes: boolean
  locationMarkers: boolean
  locationLabels: boolean
  workflowPins: boolean
  workflowLabels: boolean
  workflowMarkups: boolean
  workflowMarkupLabels: boolean
}

// A page without Workflows (Map Setup) draws none of their layers.
export const NO_WORKFLOW_LAYERS: Partial<IExportLayers> = {
  workflowPins: false,
  workflowLabels: false,
  workflowMarkups: false,
  workflowMarkupLabels: false,
}

// Basemap names start off: GL places them, so the export's own labels cannot avoid them.
export const DEFAULT_EXPORT_LAYERS: IExportLayers = {
  basemapLabels: false,
  buildings3d: false,
  locationShapes: true,
  locationMarkers: true,
  locationLabels: true,
  workflowPins: true,
  workflowLabels: true,
  workflowMarkups: true,
  workflowMarkupLabels: false,
}
